import { mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters('auth', [
      'loggedIn',
      'currentUser', 
      'authError', 
      'documentsWereRejected', 
      'signtureWasRejected', 
      'userPersonalData', 
      'verificationEmail', 
      'registerPsw', 
      'confirmRegisterPsw', 
      'expireVar', 
      'signatureVar', 
      'idVar', 
      'hashVar',
      'authLoading'
    ]),

    ...mapGetters('dashboard', [
      'dashboardData', 
      'dashboardError', 
    ]),

    ...mapGetters('tickets', [
      'ticketsData', 
      'ticketsReplyData',
      'ticketsError',
      'ticketReply'
    ]),

    ...mapGetters('darkMode', ['isDarkMode']),

    ...mapGetters('application', [ 
      'deleteDataRequestModal',
      'ticketId',
      'ticketStatus',
      'addSignatureModal', 
      'addDocumentsModal', 
      'mobileInformationModal',
      'failedVerifyModal', 
      'documentsVerifyingModal', 
 
      
      'searchRequestModal', 
      'confirmSearchRequestModal',
      'companyToSearch',
      'requestSentModal', 

      'errorProcessModal', 
      'errorProcessTitle',
      'errorProcessText',

      'successProcessModal',
      'successProcessTitle',
      'successProcessText',
     

      'skipMobileInfoModal'
    ]),

    ...mapGetters('payment', [
      'showPaymentModal',
      'subscription',
      'paymentMethods', 
      'loading',
      'error',
      'payrexxPaymentPage',
      'hasActiveSubscription',
      'subscriptionPlan',
      'nextBillingDate'
    ]),
  },
  methods: {
    ...mapActions('auth', [
      'logIn',
      'registerStep1', 
      'registerStep2', 
      'logOut', 
      'requestCleanData', 
      'checkUserIdentity', 
      'getProfilelData',
      'requestPasswordChange',
      'resetPassword'
    ]),

    ...mapActions('dashboard', ['getDashboardData']),
    
    ...mapActions('tickets', ['getTicketsData', 'getTicketsReplyData', 'getTicketReply', 'updateTicketStatus', 'getTicketFile']),

    ...mapActions('darkMode', ['initializeDarkMode', 'toggleDarkMode']),

    ...mapActions('payment', [
      'openPaymentModal',
      'closePaymentModal',
      'fetchSubscription',
      'fetchPaymentMethods',
      'createPayrexxPaymentPage',
      'updateSubscription',
      'cancelSubscription',
      'reactivateSubscription',
      'addPaymentMethod',
      'clearPayrexxPaymentPage'
    ]),

    //...mapActions('application', ['']),
  }
};
